import React, { useState } from "react";
import { aboutTranslations } from "./translation/pdAbout";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिंदी" },
  { code: "bn", label: "বাংলা" },
  { code: "mr", label: "मराठी" },
  { code: "gu", label: "ગુજરાતી" },
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" },
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "ml", label: "മലയാളം" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
  { code: "as", label: "অসমীয়া" },
  { code: "ur", label: "اردو" },
  { code: "ar", label: "العربية" },
  { code: "ja", label: "日本語" },
  { code: "zh", label: "中文" },
  { code: "ko", label: "한국어" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "ms", label: "Bahasa Melayu" },
  { code: "de", label: "Deutsch" },
  { code: "tr", label: "Türkçe" },
];

export default function PDAbout({
  selectedLanguage = "en",
  role = "General",
  currentTheme,
}) {
  const [language, setLanguage] = useState(selectedLanguage || "en");

  const roleMap = {
    mentor: "LearningPartner",
    institution: "LearningPartner",

    coordinator: "BusinessPartner",
    director: "BusinessPartner",

    student: "Student",
    parent: "Parent",
  };
  
  const normalizedRole = roleMap[role?.toLowerCase()] || "General";

  const about =
    aboutTranslations[language]?.[normalizedRole] ||
    aboutTranslations[language]?.General ||
    aboutTranslations.en?.[normalizedRole] ||
    aboutTranslations.en?.General;

  // const handleRefresh = () => {
  //   setLanguage(selectedLanguage);
  // };

  return (
    <div className="space-y-6 bg-gray-900 p-6 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
      <div
        className="
          mt-1
          rounded-2xl
          border border-purple-400/30
          bg-black/30
          backdrop-blur
          p-4
          space-y-4
        "
      >
        {/* TOP BAR */}
        <div className="flex items-center justify-between gap-3">
          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className="
              bg-gray-800
              border border-gray-600
              text-white
              rounded-lg
              px-2 py-1
              text-xs
            "
          >
            {LANGUAGES.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.label}
              </option>
            ))}
          </select>

          {/* <button
            onClick={handleRefresh}
            className="
              w-20 px-3 py-1
              rounded-lg
              border border-cyan-500/30
              bg-cyan-500
              hover:bg-cyan-700
              text-white
              transition-all
              text-xs
            "
            title="Reset Language"
          >
            🔄
          </button> */}
        </div>

        {/* TITLE */}
        <div className="text-center">
          <div className="text-sm font-bold text-cyan-300">
            {about?.title}
          </div>
        </div>

        {/* CONTENT */}
        <div className="space-y-3">
          {about?.content?.map((line, index) => (
            <div
              key={index}
              className="text-xs text-gray-200 leading-relaxed"
            >
              {line}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}